export const Info = ({ color }) => {
  return (
    <span className="info-icon" style={{ color }}>
      ?
    </span>
  );
};
